const Form = require('@ordergroove/brandy/src/app/forms/form');
const map = require('lodash/map');
const get = require('lodash/get');
const includes = require('lodash/includes');
const orderBy = require('lodash/orderBy');


const fieldsAbbreviations = { 'state': 'S' };


class AddressFormController extends Form {
  static get $inject() {
    return ['$injector', 'countries', '$http', 'publicPath', '$window'];
  }

  constructor($injector, countries, $http, publicPath, $window) {
    super();
    this.$http = $http;
    this.publicPath = publicPath;
    this.$window = $window;

    let externalCountriesConfig;
    if ($injector.has('countriesConfig')) {
      externalCountriesConfig = map($injector.get('countriesConfig'), country => angular.fromJson(country));
    }

    this.countries = (externalCountriesConfig || countries).reduce((acc, country) => {
      acc[country.code] = country;
      return acc;
    }, {});

    this.getCountriesRegions();
  }

  $onInit() {
    this.model.countryCode = this.model.countryCode || this.sortedCountries[0].code || 'US';
  }

  getCountriesRegions() {
    return this.$http({
      method: 'GET',
      url: this.i18nConfigsUrl
    }).then((response) => {
      const countriesData = response.data;
      const that = this;
      map(this.countries, (country) => {
        const countryFormatStr = get(countriesData[country.code], 'format');
        if (includes(countryFormatStr, fieldsAbbreviations['state'])) {
          that.countries[country.code]['displayRegionsField'] = true;
        }

        const countryRegions = get(countriesData[country.code], 'regions');
        if (countryRegions && countryRegions.length) {
          that.countries[country.code]['regions'] = countryRegions;
        }
      });
    }).catch(() => (null));
  }

  get sortedCountries() {
    const countries = Object.values(this.countries);
    return orderBy(countries, ['name']);
  }

  get i18nConfigsUrl() {
    if (!/^https?:/.test(this.publicPath)) {
      this.publicPath = this.$window.location.protocol + this.publicPath;
    }

    const url = new URL(this.publicPath);

    return `${url.origin}/@ordergroove/i18n-data/latest`;
  }

  get regions() {
    return this.countries[this.model.countryCode].regions;
  }
}


module.exports = AddressFormController;

angular.module('msi.addresses')
  .controller('AddressFormController', AddressFormController);
